// extracted by mini-css-extract-plugin
export default {"root":"CGwJK","rootLarge":"X8QXo","title":"mrbx0","button":"OYI27","rootSmall":"ixepO","inner":"A4MKq","main":"r8sn3","info":"IrW9B","infoLink":"SV7_S","infoIcon":"x6Gl5"};